// extracted by mini-css-extract-plugin
export default {"wrapper":"nV-z","ratingContainer":"oV-z","ratingValue":"pV-z","starSprite":"qV-z","ratingLabel":"rV-z","error":"sV-z","errorBox":"tV-z"};